import React, { useContext } from 'react';
import classes from './Footer.module.scss';
import {
  SiteContext,
  selectUnitId,
  selectSupportParams,
} from '@homeplay/app';
import WhatsAppLink from '../WhatsAppLink';
import ScrollArrows from '../ScrollArrows';
import { useSelector } from 'react-redux';
import ContactInfoWidget from '../LiveChatWidget/components/ContactInfoWidget';

const Footer = () => {
  const { siteName, isTouchUnit} = useContext(SiteContext);
  const unitId = useSelector(selectUnitId);
  const supportParams = useSelector(selectSupportParams);

  let support = null;

  if (unitId && !isTouchUnit && supportParams) {
    if (supportParams.useChat) {
      // NOTE: ChatWidget is now rendered in Layout to prevent re-mounting on navigation
      support = null;
    } else if (supportParams.whatsapp) {
      support = <WhatsAppLink phoneNumber={supportParams.whatsapp} />;
    } else {
      support = <ContactInfoWidget />;
    }
  } else if (unitId && !isTouchUnit) {
    support = <ContactInfoWidget />;
  }

  return (
    <React.Fragment>
      <footer className={classes.Footer}>
        {siteName && <p>Site Name: {siteName}</p>}
        <p>ID {unitId}</p>
        {support}
      </footer>
      {isTouchUnit && <ScrollArrows />}
    </React.Fragment>
  );
};

export default Footer;
